import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/refinancia/JC-colombia-horizontal.png'
import _imports_1 from '@/assets/img/Logo-tranqui.png'
import _imports_2 from '@/assets/img/Liquitty_Negro_SinFondo.png'
import _imports_3 from '@/assets/img/Logo-System.png'
import _imports_4 from '@/assets/img/Logo-Cobro.png'
import _imports_5 from '@/assets/img/Logo-Valora.png'
import _imports_6 from '@/assets/img/x-circle.svg'
import _imports_7 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-1cdab0ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrap" }
const _hoisted_2 = { class: "login-wrap__slogan" }
const _hoisted_3 = { class: "slogan-shadow-mobile__wrap" }
const _hoisted_4 = { class: "slogan-shadow-mobile" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div data-v-1cdab0ff><div class=\"slogan-logos-content\" data-v-1cdab0ff><div class=\"slogan-logos-content__wrap\" data-v-1cdab0ff><img class=\"w-3/4 mx-auto\" src=\"" + _imports_0 + "\" alt=\"\" data-v-1cdab0ff></div><span class=\"text-primary md:text-4xl md:w-full md:mb-4\" data-v-1cdab0ff> Le damos la bienvenida a su Sucursal Virtual </span></div><div class=\"slogan-shadow-mobile__title\" data-v-1cdab0ff><span class=\"text-2xl font-extrabold color-green md:text-4xl\" data-v-1cdab0ff> Quiénes Somos </span></div><div class=\"text-primary md:text-lg\" style=\"text-align:justify;padding:1.25rem;\" data-v-1cdab0ff> JC Colombia es su socio de confianza para afrontar los desafíos financieros y recuperar el control de su futuro financiero. Desde nuestros inicios, nos hemos comprometido a brindar un servicio de recuperación de deudas que sea transparente, empático y amigable para el consumidor. Entendemos que gestionar deudas puede ser desafiante, por eso nos esforzamos por hacer que el proceso sea lo más sencillo y accesible posible. A través de nuestra plataforma en línea segura, puede acceder fácilmente a la información de su cuenta y explorar opciones de pago adaptadas a tus necesidades. Nuestro objetivo es brindarle las herramientas y recursos necesarios para que tome el control de su bienestar financiero. </div></div>", 1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"slogan-shadow-mobile__title\" data-v-1cdab0ff><span class=\"text-2xl font-extrabold color-green md:text-3xl\" data-v-1cdab0ff> Nuestros aliados </span></div><div class=\"text-primary md:text-lg\" style=\"text-align:justify;padding:1.25rem;\" data-v-1cdab0ff> En JC Colombia creemos que cada persona merece una nueva oportunidad para reconectarse con su bienestar financiero. Por eso, trabajamos bajo un modelo multiservicer, con empresas especializadas en la gestión de cartera para ofrecer soluciones más personalizadas, eficientes y humanas. Nuestros aliados comparten nuestro compromiso con la transparencia, el respeto y la búsqueda de alternativas que se ajusten a la realidad de cada cliente, identificando la mejor forma de acompañarte en el camino hacia una salud financiera sostenible. A continuación, te presentamos las empresas con las que trabajamos de la mano para hacer esto posible: </div><div class=\"aliados-logos\" data-v-1cdab0ff><div class=\"aliados-logos__wrap\" data-v-1cdab0ff><div class=\"w-full md:w-1/6\" data-v-1cdab0ff><img class=\"w-full\" src=\"" + _imports_1 + "\" alt=\"\" data-v-1cdab0ff></div><div class=\"w-full md:w-1/6\" data-v-1cdab0ff><img class=\"w-full\" src=\"" + _imports_2 + "\" alt=\"\" data-v-1cdab0ff></div><div class=\"w-full md:w-1/6\" data-v-1cdab0ff><img class=\"w-full\" src=\"" + _imports_3 + "\" alt=\"\" data-v-1cdab0ff></div><div class=\"w-full md:w-1/6\" data-v-1cdab0ff><img class=\"w-full\" src=\"" + _imports_4 + "\" alt=\"\" data-v-1cdab0ff></div><div class=\"w-full md:w-1/6\" data-v-1cdab0ff><img class=\"w-full\" src=\"" + _imports_5 + "\" alt=\"\" data-v-1cdab0ff></div></div></div>", 3)
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close__icon",
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "login-wrap__form-wrap" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "my-4 md:my-10 mt-14 w-40 md:w-60 block",
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "form-wrap__input"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-xs font-bold text-primary" }, "Seleccione el pais", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "text-red-500" }
const _hoisted_17 = { class: "form-wrap__input" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-xs font-bold text-primary" }, "Tipo de documento", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "text-red-500" }
const _hoisted_21 = { class: "form-wrap__input" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-xs font-bold text-primary" }, "Número de documento", -1))
const _hoisted_23 = { class: "text-xs text-red-500" }
const _hoisted_24 = { class: "form-wrap__input" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-xs font-bold text-primary" }, "Número de celular", -1))
const _hoisted_26 = { class: "text-xs text-red-500" }
const _hoisted_27 = { class: "form-wrap__input" }
const _hoisted_28 = { class: "text-xs text-gray-600" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "text-primary hover:underline",
  rel: "nofollow noopener",
  href: "/politica-tratamiento-datos",
  target: "_blank"
}, " política de tratamiento de datos ", -1))
const _hoisted_30 = { class: "text-xs text-red-500" }
const _hoisted_31 = { class: "form-wrap__input" }
const _hoisted_32 = { class: "text-xs text-gray-600" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "text-primary hover:underline",
  rel: "nofollow noopener",
  href: "/terminos-condiciones",
  target: "_blank"
}, "terminos y condiciones", -1))
const _hoisted_34 = { class: "text-xs text-red-500" }
const _hoisted_35 = {
  key: 1,
  class: "py-3"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center py-3",
  id: "recaptcha"
}, null, -1))
const _hoisted_37 = { class: "text-red-500" }
const _hoisted_38 = { class: "text-center w-60" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ModalConfirmSms = _resolveComponent("ModalConfirmSms")!
  const _component_ModalContactChannels = _resolveComponent("ModalContactChannels")!
  const _component_RefinancaBanner = _resolveComponent("RefinancaBanner")!
  const _component_CookieConsent = _resolveComponent("CookieConsent")!
  const _component_OfficialCommunicationPopup = _resolveComponent("OfficialCommunicationPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", {
              class: "login-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isActive = !_ctx.isActive))
            }, " Ingresar "),
            _hoisted_6
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["login-wrap__form", { activeForm: _ctx.isActive }])
      }, [
        _createElementVNode("button", {
          class: "login-wrap__form-close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isActive = !_ctx.isActive))
        }, _hoisted_10),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_Form, {
            onSubmit: _ctx.sendSms,
            "validation-schema": _ctx.schemaLoginForm,
            class: "flex flex-col items-center justify-items-center"
          }, {
            default: _withCtx(({ errors }) => [
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_Field, {
                      name: "country_code",
                      as: "select",
                      class: _normalizeClass(["px-3 text-sm bg-transparent border-2 border-gray-300 rounded w-60 text-gris80 focus:outline-none", { 'border-b border-primary': errors.country }]),
                      value: _ctx.selectCountryDefault
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectCountry, (country, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: country.value
                          }, _toDisplayString(country.text), 9, _hoisted_15))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["class", "value"]),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(errors.country), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_Field, {
                  name: "document_type",
                  as: "select",
                  class: _normalizeClass(["px-3 text-sm bg-transparent border-2 border-gray-300 rounded w-60 text-gris80 focus:outline-none", { 'border-b border-primary': errors.documentType }]),
                  value: _ctx.selectDefault
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectTypes, (listType, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: listType.value
                      }, _toDisplayString(listType.text), 9, _hoisted_19))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["class", "value"]),
                _createElementVNode("div", _hoisted_20, _toDisplayString(errors.documentType), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Field, {
                  name: "identification",
                  type: "text",
                  as: "input",
                  class: _normalizeClass(["bg-transparent border-2 border-gray-300 fw__input-inp w-60", { 'border border-primary': errors.identification }]),
                  inputmode: "numeric"
                }, null, 8, ["class"]),
                _createElementVNode("div", _hoisted_23, _toDisplayString(errors.identification), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_Field, {
                  name: "phone_number",
                  type: "text",
                  as: "input",
                  class: _normalizeClass(["bg-transparent border-2 border-gray-300 fw__input-inp w-60", { 'border border-primary': errors.phone_number }]),
                  inputmode: "numeric"
                }, null, 8, ["class"]),
                _createElementVNode("div", _hoisted_26, _toDisplayString(errors.phone_number), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("p", _hoisted_28, [
                  _createVNode(_component_Field, {
                    name: "checkbox",
                    type: "checkbox",
                    as: "input",
                    class: _normalizeClass(["mr-2 checkbox-btn", { 'border border-primary': errors.checkbox }]),
                    value: true,
                    "unchecked-value": false
                  }, null, 8, ["class"]),
                  _createTextVNode(" Acepto "),
                  _hoisted_29
                ]),
                _createElementVNode("div", _hoisted_30, _toDisplayString(errors.checkbox), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("p", _hoisted_32, [
                  _createVNode(_component_Field, {
                    name: "checkbox_terminos",
                    type: "checkbox",
                    as: "input",
                    class: _normalizeClass(["mr-2 checkbox-btn", { 'border border-primary': errors.checkbox_terminos }]),
                    value: true,
                    "unchecked-value": false
                  }, null, 8, ["class"]),
                  _createTextVNode(" Acepto "),
                  _hoisted_33
                ]),
                _createElementVNode("div", _hoisted_34, _toDisplayString(errors.checkbox_terminos), 1)
              ]),
              (_ctx.showRecaptcha)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode(_component_Field, {
                      type: "hidden",
                      name: "captcha",
                      modelValue: _ctx.successReCaptcha,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.successReCaptcha) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(errors.captcha), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "px-4 py-2 text-sm font-normal text-white transition duration-300 ease-in-out border-2 rounded-lg bg-primary focus:shadow-outline md:flex-row focus:outline-none",
                  disabled: _ctx.sendingLoading
                }, [
                  (_ctx.sendingLoading && !_ctx.showModalSms)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Ingresando ...")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Ingresar")
                      ], 64))
                ], 8, _hoisted_39)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createVNode(_component_ModalConfirmSms, {
        "is-visible": _ctx.showModalSms,
        "data-form": _ctx.dataForm,
        onLogin: _ctx.login,
        onResendSms: _ctx.resendSms,
        "sending-loading": _ctx.sendingLoading,
        "sending-success": _ctx.sendingSuccess,
        "login-loading": _ctx.loginLoading,
        onClose: _ctx.closeModalConfirmSms
      }, null, 8, ["is-visible", "data-form", "onLogin", "onResendSms", "sending-loading", "sending-success", "login-loading", "onClose"]),
      _createVNode(_component_ModalContactChannels, {
        "is-visible": _ctx.showModalContactChannels,
        title: _ctx.contactChannelsTitle,
        description: _ctx.contactChannelsDescription,
        onClose: _ctx.closeModalContactChannels
      }, null, 8, ["is-visible", "title", "description", "onClose"])
    ]),
    false
      ? (_openBlock(), _createBlock(_component_RefinancaBanner, {
          key: 0,
          isCookieVisible: _ctx.isCookieVisible
        }, null, 8, ["isCookieVisible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_CookieConsent, { onCookieStatusChange: _ctx.onCookieStatusChange }, null, 8, ["onCookieStatusChange"]),
    _createVNode(_component_OfficialCommunicationPopup)
  ], 64))
}